import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div`
  position: absolute;
  top: 0;
`;

export const Title = styled.h1`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  color: ${theme.colors.primary};
  font-size: max(14px, 1.3vw);
  padding-top:5vh;
`;

export const HelperTitle  = styled.h1`
  margin-left:1vw;
  font-size: max(14px, 1.3vw);
`;